import { IconProps } from "../types/icon";

export const ShopIcon = ({
  className = "",
  size = 16,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill={color}>
        <path d="m15.9 4.553-2-4A1 1 0 0 0 13 0H3a1 1 0 0 0-.895.553l-2 4A1 1 0 0 0 0 5a2 2 0 0 0 3.5 1.321 2 2 0 0 0 3 0 2 2 0 0 0 3 0 2 2 0 0 0 3 0A2 2 0 0 0 16 5a1 1 0 0 0-.1-.447M13 14h-3v-3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3H3V8H1v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8h-2z" />
      </g>
    </svg>
  );
};
